<template>
    <div class="address__input-group-wrapper">
        <div class="row">
            <div class="col-4 col-md-2">
                <div class="js--validate-input"
                     data-model="addressSalutation"
                     data-validate>
                    <salutation-select :address-type="addressType"
                                       :address-data="value"
                                       :enabled-address-fields="optionalAddressFields"
                                       @input="emitInputEvent($event.field, $event.value)">
                    </salutation-select>
                </div>
            </div>
            <div class="col-12 col-xs-sm--m-t-16 col-md-5">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="name2">
                    <input type="text"
                           name="firstName"
                           :title="$translate('Ceres::Template.addressFirstName')"
                           :placeholder="$translate('Ceres::Template.addressFirstName')"
                           :id="'txtFirstName' + _uid"
                           :value="value.name2"
                           @input="emitInputEvent('name2', $event.target.value)">
                    <label :for="'txtFirstName' + _uid">
                        {{ $translate("Ceres::Template.addressFirstName") }}*
                    </label>
                </div>
            </div>
            <div class="col-12 col-xs-sm--m-t-16 col-md-5">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="name3">
                    <input type="text"
                           name="lastName"
                           :title="$translate('Ceres::Template.addressLastName')"
                           :placeholder="$translate('Ceres::Template.addressLastName')"
                           :id="'txtLastName' + _uid"
                           :value="value.name3"
                           @input="emitInputEvent('name3', $event.target.value)">
                    <label :for="'txtLastName' + _uid">
                        {{ $translate("Ceres::Template.addressLastName") }}*
                    </label>
                </div>
            </div>
        </div>

        <div v-if="value.gender === 'company'"
             class="row row--m-t-16">
            <div class="col-12 col-md-6">
                <div class="input__wrapper"
                     data-model="name1">
                    <input type="text"
                           name="company"
                           :title="$translate('Ceres::Template.addressCompany')"
                           :placeholder="$translate('Ceres::Template.addressCompany')"
                           :id="'txtCompany' + _uid"
                           :value="value.name1"
                           @input="emitInputEvent('name1', $event.target.value)">
                    <label :for="'txtCompany' + _uid">
                        {{ $translate("Ceres::Template.addressCompany") }}
                    </label>
                </div>
            </div>
            <div class="col-12 col-xs-sm--m-t-16 col-md-6">
                <div class="input__wrapper"
                     data-model="vatNumber">
                    <input type="text"
                           name="vatNumber"
                           :title="$translate('Ceres::Template.addressVatNumber')"
                           :placeholder="$translate('Ceres::Template.addressVatNumber')"
                           :id="'txtVatNumber' + _uid"
                           :value="value.vatNumber"
                           @input="emitInputEvent('vatNumber', $event.target.value)">
                    <label :for="'txtVatNumber' + _uid">
                        {{ $translate("Ceres::Template.addressVatNumber") }}
                    </label>
                </div>
            </div>
        </div>

        <div class="row row--m-t-16">
            <div class="col-9 col-md-6">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="address1">
                    <input type="text"
                           name="street"
                           :title="$translate('Ceres::Template.addressStreet')"
                           :placeholder="$translate('Ceres::Template.addressStreet')"
                           :id="'txtStreet' + _uid"
                           :value="value.address1"
                           @input="emitInputEvent('address1', $event.target.value)">
                    <label :for="'txtStreet' + _uid">
                        {{ $translate("Ceres::Template.addressStreet") }}*
                    </label>
                </div>
            </div>
            <div class="col-3 col-md-1">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="address2">
                    <input type="text"
                           name="housenumber"
                           :title="$translate('Ceres::Template.addressNumber')"
                           :placeholder="$translate('Ceres::Template.addressNumber')"
                           :id="'txtNumber' + _uid"
                           :value="value.address2"
                           @input="emitInputEvent('address2', $event.target.value)">
                    <label :for="'txtNumber' + _uid">
                        {{ $translate("Ceres::Template.addressNumber") }}*
                    </label>
                </div>
            </div>
            <div class="col-12 col-xs-sm--m-t-16 col-md-5">
                <div class="input__wrapper"
                     data-model="address3">
                    <input type="text"
                           name="decorateAddress"
                           :title="$translate('ODNaPo::NaPo.checkoutAddressAdditional')"
                           :placeholder="$translate('ODNaPo::NaPo.checkoutAddressAdditional')"
                           :id="'decorateAddress0' + _uid"
                           :value="value.address3"
                           @input="emitInputEvent('address3', $event.target.value)">
                    <label :for="'decorateAddress0' + _uid">
                        {{ $translate("ODNaPo::NaPo.checkoutAddressAdditional") }}
                    </label>
                </div>
            </div>
        </div>
        <div class="row row--m-t-16">
            <div class="col-4 col-md-2">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="postalCode">
                    <input type="text"
                           name="zip"
                           :title="$translate('Ceres::Template.addressZip')"
                           :placeholder="$translate('Ceres::Template.addressZip')"
                           :id="'txtZip' + _uid"
                           :value="value.postalCode"
                           @input="emitInputEvent('postalCode', $event.target.value)">
                    <label :for="'txtZip' + _uid">
                        {{ $translate("Ceres::Template.addressZip") }}*
                    </label>
                </div>
            </div>
            <div class="col-8 col-md-4">
                <div class="input__wrapper"
                     data-validate="text"
                     data-model="town">
                    <input type="text"
                           name="town"
                           :title="$translate('Ceres::Template.addressPlace')"
                           :placeholder="$translate('Ceres::Template.addressPlace')"
                           :id="'txtPlace' + _uid"
                           :value="value.town"
                           @input="emitInputEvent('town', $event.target.value)">
                    <label :for="'txtPlace' + _uid">
                        {{ $translate("Ceres::Template.addressPlace") }}*
                    </label>
                </div>
            </div>
            <div class="col-12 col-xs-sm--m-t-16 col-md-6">
                <div class="js--validate-input"
                     data-model="countryId"
                     data-validate>
                    <country-select
                            :selected-country-id="value.countryId"
                            :selected-state-id="value.stateId"
                            @country-changed="onSelectedCountryChanged($event)"
                            @state-changed="emitInputEvent('stateId', $event)"
                            :address-type="addressType"
                            :optional-address-fields="optionalAddressFields"
                            :required-address-fields="requiredAddressFields">
                    </country-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SalutationSelect from "./SalutationSelect.vue";
import CountrySelect from "./CountrySelect.vue";
import VatId from "ceres/app/components/customer/VatId.vue";

export default {

    name: "address-input-group",

    components:
    {
        SalutationSelect,
        CountrySelect,
        VatId
    },

    props:
    {
        defaultCountry: {
            type: String,
            default: "DE"
        },
        addressType: String,
        modalType: String,
        template: String,
        value: {
            type: Object,
            default()
            {
                return {};
            }
        },
        optionalAddressFields: {
            type: Object,
            default: () =>
            {
                return {
                    de:[],
                    uk:[]
                };
            }
        },
        requiredAddressFields: {
            type: Object,
            default: () =>
            {
                return {
                    de:[],
                    uk:[]
                };
            }
        },
        defaultSalutation: {
            type: String,
            default: "male"
        }
    },

    computed:
    {
        isMyAccount()
        {
            return App.templateType === "my-account";
        },

        isPickupStation()
        {
            return this.value && this.value.address1 === "PACKSTATION" && this.isParcelBoxAvailable;
        },

        isPostOffice()
        {
            return this.value && this.value.address1 === "POSTFILIALE" && this.isPostOfficeAvailable;
        },

        isParcelOrOfficeAvailable()
        {
            return (this.isParcelBoxAvailable || this.isPostOfficeAvailable || this.isMyAccount) && this.selectedCountry && this.selectedCountry.isoCode2 === "DE" && this.addressType === "2";
        },

        ...mapState({
            isParcelBoxAvailable: state => state.checkout.shipping.isParcelBoxAvailable,
            isPostOfficeAvailable: state => state.checkout.shipping.isPostOfficeAvailable
        })
    },

    data()
    {
        return {
            stateList  : [],
            countryLocaleList: ["DE", "GB"],
            localeToShow: this.defaultCountry,
            selectedCountry: null
        };
    },

    methods:
    {
        /**
         * Update the address input group to show.
         * @param shippingCountry
         */
        onSelectedCountryChanged(shippingCountry)
        {
            this.selectedCountry = shippingCountry;

            if (this.countryLocaleList.indexOf(shippingCountry.isoCode2) >= 0)
            {
                this.localeToShow = shippingCountry.isoCode2;
            }
            else
            {
                this.localeToShow = this.defaultCountry;
            }

            this.emitInputEvent("countryId", shippingCountry.id);

            if (this.isPickupStation || this.isPostOffice)
            {
                this.togglePickupStation(false);
            }
        },

        togglePickupStation(showPickupStation)
        {
            const emitInputs =
                {
                    address1: "",
                    address2: "",
                    address3: "",
                    showPickupStation: showPickupStation
                };

            if (showPickupStation)
            {
                emitInputs.address1 = this.isParcelBoxAvailable ? "PACKSTATION" : "POSTFILIALE";
            }

            for (const input in emitInputs)
            {
                this.emitInputEvent(input, emitInputs[input]);
            }
        },

        /**
         * @param {string} field
         * @param {number} value
         */
        emitInputEvent(field, value)
        {
            this.$emit("input", { field, value });
        },

        isInOptionalFields(locale, key)
        {
            return this.optionalAddressFields[locale].includes(key);
        },

        isInRequiredFields(locale, key)
        {
            return (this.requiredAddressFields && this.requiredAddressFields[locale] && this.requiredAddressFields[locale].includes(key));
        },

        transformTranslation(translationKey, locale, addressKey)
        {
            const translation = this.$translate(translationKey);
            const isRequired = this.isInRequiredFields(locale, addressKey);

            return translation + (isRequired ? "*" : "");
        },

        areNameFieldsShown(locale, keyPrefix)
        {
            const isSalutationActive = this.isInOptionalFields(locale, `${keyPrefix}.salutation`);
            const isContactPersonActive = this.isInOptionalFields(locale, `${keyPrefix}.contactPerson`);
            const isName1Active = this.isInOptionalFields(locale, `${keyPrefix}.name1`);
            const isSelectedSalutationCompany = this.value.gender === "company";

            const condition1 = isSalutationActive && isContactPersonActive && isSelectedSalutationCompany;
            const condition2 = !isSalutationActive && isName1Active && isContactPersonActive;

            return !(condition1 || condition2);
        },

        areNameFieldsRequired(locale, keyPrefix)
        {
            const isSalutationActive = this.isInOptionalFields(locale, `${keyPrefix}.salutation`);
            const isName1Active = this.isInOptionalFields(locale, `${keyPrefix}.name1`);
            const isContactPersonRequired = this.isInRequiredFields(locale, `${keyPrefix}.contactPerson`);
            const isSelectedSalutationCompany = this.value.gender === "company";

            const condition1 = isSalutationActive && !isSelectedSalutationCompany;
            const condition2 = isSalutationActive && isSelectedSalutationCompany && isContactPersonRequired;
            const condition3 = !isSalutationActive && isName1Active && isContactPersonRequired;
            const condition4 = !isSalutationActive && !isName1Active;

            return condition1 || condition2 || condition3 || condition4;
        }
    }
}
</script>
